// src/components/Footer.js
import { Link as RouterLink } from 'react-router-dom';
import { Stack, Typography, Link, Box, Divider } from '@mui/material';

const Footer = () => {
  return (
    <>
      <Divider sx={{ mb: 3 }} />
      <Stack direction="row" gap={2} justifyContent="flex-end" alignItems="center" flexWrap="wrap">
        <Link
          component={RouterLink}
          to="/contact"
          underline="hover"
          variant="body2"
        >
          お問合わせ
        </Link>
        <Link
          component={RouterLink}
          to="/company"
          underline="hover"
          variant="body2"
        >
          特定商取引法に基づく表示
        </Link>
        <Typography variant="body2" color="text.secondary">
          &copy; Nocstela Inc. or Tendenec
        </Typography>
      </Stack>
    </>
  );
};

export default Footer;
